import type { VariablesView } from './scopes'

export interface VariablesSearch {
  tab?: VariablesView
  /** Selected location / group / display / campaign id of the scoped tabs. */
  scope?: string
}

const VIEWS: readonly VariablesView[] = ['global', 'location', 'display_group', 'display', 'campaign']

export function validateVariablesSearch(s: Record<string, unknown>): VariablesSearch {
  const tab = typeof s.tab === 'string' && (VIEWS as readonly string[]).includes(s.tab) ? (s.tab as VariablesView) : undefined
  const scope = typeof s.scope === 'string' && /^[0-9A-Za-z]{1,64}$/.test(s.scope) ? s.scope : undefined
  return { ...(tab ? { tab } : {}), ...(scope && tab && tab !== 'global' ? { scope } : {}) }
}
